import React, { ReactNode } from "react";
import "./LearningPage.css";

type LearningPageRelatedActivitiesProps = {
  readonly children: ReactNode;
};

export default function LearningPageRelatedActivities({
  children,
}: LearningPageRelatedActivitiesProps) {
  return <aside className="related-activities">{children}</aside>;
}
